'use client';

import { useEffect } from 'react';

import { TOLD_SDK_LOADED_EVENT } from '@/core/analytics/constants';

type IdentifiedUser = {
  userId: string;
  email: string;
  name: string | null;
};

export const ToldIdentifyClient = ({
  user,
}: {
  user: IdentifiedUser | null;
}) => {
  useEffect(() => {
    if (user === null) return;

    const identify = () => {
      if (typeof told === 'undefined') return;
      told('identify', {
        email: user.email,
        userId: user.userId,
        name: user.name,
      });
    };

    if (typeof told !== 'undefined') {
      identify();
      return;
    }

    window.addEventListener(TOLD_SDK_LOADED_EVENT, identify, { once: true });
    return () => window.removeEventListener(TOLD_SDK_LOADED_EVENT, identify);
  }, [user]);

  return null;
};
